/**
 * @file 汇总信息
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';
import { PopOver, OverlayTrigger } from '@tencent/spaui';
import FinanceAlertTip from '@/business-components/finance-alert-tip';

import './index.scoped.less';

export enum SummaryTheme {
  theme1 = 'theme1',
  theme2 = 'theme2',
}

interface SummaryProps {
  /* schema */
  schema: Record<string, any>[];
  /* 获取数据 */
  getValue: (item: Record<string, any>) => any;
  /* 主题 */
  theme?: SummaryTheme;
}

export const Summary: React.FC<SummaryProps> = (props) => {
  const { schema = [], getValue, theme = SummaryTheme.theme1 } = props;

  const renderSummary = (v: any) => {
    const { label, data = [], width, style, icon, showFinanceAlert } = v;
    return (
      <div
        className="summary"
        style={{ width, ...(style || {}) }}
      >
        <div className="summary-header">
          {icon ? <span className={classnames('icon', icon)}></span> : null}
          {label ? <>
            <span className="label">{label}</span>
            {showFinanceAlert && <FinanceAlertTip />}
          </> : null}
        </div>
        <div className="summary-body">
          {
            data.map((group: any) => renderGroup(group))
          }
        </div>
      </div>
    );
  };

  const renderGroup = (group: any) => {
    const { label, data = [], width, style } = group;
    return (
      <div
        className="summary-group"
        style={{ width, ...(style || {}) }}
      >
        <div className="summary-group-header">
          {label ? <span className="label">{label}</span> : null}
        </div>
        <div className="summary-group-body">
          {
            data.map((v: any) => renderItem(v))
          }
        </div>
      </div>
    );
  };

  const renderItem = (item: any) => {
    const { key, label, width, style, className, tip, onClick } = item;
    const value = getValue(item);
    return (
      <OverlayTrigger
        key={key}
        overlay={
          <PopOver>{tip || value}</PopOver>
        }
      >
        <div
          className="summary-group-item"
          style={{ width, ...(style || {}) }}
        >
          {label ? <div className="label">{label}</div> : null}
          <div
            className={classnames('value', className)}
            {...(_.isFunction(onClick) ? { onClick } : {})}
          >
            {value}
          </div>
        </div>
      </OverlayTrigger>
    );
  };

  return (
    <div className={classnames('summary-list', theme)}>
      {
        schema.map((v: any) => renderSummary(v))
      }
    </div>
  );
};

export default Summary;
